<template>
  <div>
      <section class="breadcrumb-area breadcrumb-area2">
      <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="breadcrumb-content">
                    <h2 class="breadcrumb__title">对教育怀揣敬畏之心，用爱成就每一位学生</h2>
                     <p class="breadcrumb__meta"><span class="seller-badge">专业师资陪你成长</span></p>
                </div><!-- end breadcrumb-content -->
            </div><!-- end col-lg-12 -->
        </div><!-- end row -->
      </div><!-- end container -->
    </section>
      <section class="blog-area blog-area3">
           
        <div class="container">
            <div class="section-heading">
                      <div class="section__divider"></div>
                        <h2 class="section__title">师资力量</h2>
                    </div><!-- end section-heading -->
            <div class="row blog-post-wrapper">
                <div class="col-lg-6 blog-post-item" v-for="(article,index) in articles" :key="index">
                    
                    <div class="blog-post-img" v-show="index!==2&&index!==3">
                        <img v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`" :alt="article.title" class="blog__img">
                    </div><!-- end blog-post-img -->
                    <div class="post-body">
                        <div class="blog-title">
                            <router-link
                                :to="`/views/info/${article.plateid}/${article._id}`"
                                target="_blank"
                                >{{article.title}}</router-link
                                >
                        </div>
                        <div class="blog-desp">
                            <p>{{article.description}}</p>
                        </div>
                    </div><!-- end post-body -->
                     <div class="blog-post-right-img" v-show="index==2||index==3">
                        <img v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`" :alt="article.title" class="blog__img11">
                    </div><!-- end blog-post-img -->
                </div><!-- end blog-post-item -->
            </div><!-- end row -->
            
        </div><!-- end container -->
    </section><!-- end blog-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        articles:[],
        plateId:"",
    };
  },

  components: {},

  computed: {},

  mounted() {
    let plateId = this.$route.params.plateId;
    this.plateId = plateId;
    this.$axios.get(`/api/articles?plateid=${plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt`).then((res) => {
        if (res.data) {
            this.intTotal =res.data.total;
            this.articles = res.data.data;
        }
    });
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      toPage(intcount){
         
        this.intCurrent = intcount;
        this.$axios.get(`/api/articles?plateid=${this.plateId}&page=${this.intCurrent}&limit=6&sort=-createdAt`).then((res) => {
            if (res.data) {
                this.intTotal =res.data.total;
                this.articles = res.data.data;
                 this.toTop();
            }
        });
    },
  }
}

</script>
<style scoped>

.breadcrumb-area2{
  background: url('/static/images/bg_001.png') repeat-x  top;
  margin:  auto;
  margin-top: 11px;
  width: 1200px;
  height: 270px;
}
.breadcrumb-content{
  margin: 60px 66px;
}
.seller-badge{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
}
.breadcrumb__title{
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
        line-height: 92px;
    text-align: center;
}
.breadcrumb__list{
      font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.breadcrumb__list a{
      font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.breadcrumb__meta{
     text-align: center;
}
.blog-post-wrapper{
    margin-top:36px;
}
.blog-post-img{
    display: inline-block;
}
.blog-post-img img{
        width: 298px;
    height: 297px;
}
.blog-post-right-img{
    display: inline-block;
    left: 298px;
    position: relative;
}
.blog-post-right-img img{
        width: 298px;
    height: 297px;
}
.post-body{
    display: inline-block;
    display: inline-block;
    width: 283px;
    height: 297px;
    background: #FFFFFF;
    width: 298px;
    height: 297px;
    background: #FFFFFF;
    position: absolute;
    padding: 26px;
}
.row{
    margin-right: 0px;
    margin-left: 0px;
}
.blog-post-item{
        padding-right: 0px;
    padding-left: 0px;
}
.blog-title a{
        font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #313F57;
    
    line-height:72px;
}
.blog-desp{
    font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #61696F;
}
</style>